import { getAppPath } from "constants/path"
let propertyId = localStorage.getItem("propertyId")
let userEmail = localStorage.getItem("userEmail")


export const setProperty = (property, preventReload) => {
  propertyId = property.id;
  localStorage.setItem("propertyId", propertyId);
  localStorage.setItem("userEmail", property.userEmail)
  if (preventReload) return
  window.location.replace(getAppPath(propertyId))
}

export const getUserEmail = () => {
  return userEmail
}

export const getPropertyId = (ifAppStart) => {
  if (ifAppStart) {
    if (window.location.pathname.split("/")[1]) {
      return window.location.pathname.split("/")[1]
    } else {
      return propertyId || window.location.pathname.split("/")[1]
    }
  } else {
    return window.location.pathname.split("/")[1] || propertyId
  }
}

export const getDrawerState = () => {
  if (localStorage.getItem("drawer") === "true") return true;
  return false;
}


export const setPropertyIdLocalStorage = (propertyId) => {
  localStorage.setItem("propertyId", propertyId);
}
export const premiumApps = ["hyBlast", "hyALM", "hyRaf", "hyEvents"];

export const globalTohyMail = {
  hyBlast: {
    name: "Blasts",
    url: "blast",
  },
  hyALM: {
    name: "Drips",
    url: "drips",
  },
  hyRaf: {
    name: "Raf",
    url: "hyraf",
  },
  hyEvents: {
    name: "Events",
    url: "events",
  },
};